import React from 'react';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CloseBold from '@wix/da-ds/pkg/Icons/CloseBold';
import noop from '../../utils/noop';
import AlternatePopoverContent from '../PopoverContent/AlternatePopoverContent';
import type { PrimaryPlacement, SecondaryPlacement } from '@wix/da-ds/pkg/popper/types';

import s from './BasicTooltip.scss';

export interface Props {
  wrapperClassName?: string;
  contentClassName?: string;
  withCloseButton?: boolean;
  closeOnOutsideClick?: boolean;
  /** this shifts the arrow around */
  placement: PrimaryPlacement;
  secondaryPlacement?: SecondaryPlacement;
  children: React.ReactNode;
  onClose?: () => void;
}

/** This is basically a wrapper to keep this component working without updating all consumers for now
 * TODO: clean this shit up
 */
const BasicTooltip = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      wrapperClassName,
      contentClassName,
      withCloseButton,
      closeOnOutsideClick = true,
      placement,
      children,
      secondaryPlacement,
      onClose = noop,
    },
    innerRef
  ) => {
    return (
      <AlternatePopoverContent
        ref={innerRef}
        effectivePlacement={placement}
        effectiveSecondaryPlacement={secondaryPlacement}
        wrapperClassName={wrapperClassName}
        contentClassName={contentClassName}
        onClickOutside={closeOnOutsideClick ? onClose : undefined}
      >
        {children}
        {withCloseButton && (
          <PlainButtonOrLink className={s['close']} onClick={onClose}>
            <CloseBold size={IconSize.SMALLER} disableDefaultColors />
          </PlainButtonOrLink>
        )}
      </AlternatePopoverContent>
    );
  }
);
BasicTooltip.displayName = 'BasicTooltip';

export default BasicTooltip;
